var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletPana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.2,60.9a34.27,34.27,0,1,1-39-28.7A34.22,34.22,0,0,1,184.2,60.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.14,62.12a26.12,26.12,0,1,1-29.71-21.87A26.09,26.09,0,0,1,176.14,62.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,61.31c-.15,0-.43-1.09-1.15-3a27.72,27.72,0,0,0-4.17-7.47,26.56,26.56,0,0,0-4.13-4.17,25.63,25.63,0,0,0-5.72-3.5,25.82,25.82,0,0,0-7.11-2,25.23,25.23,0,0,0-3.91-.2,26.35,26.35,0,0,0-4,.41,27.43,27.43,0,0,0-3.89,1A24.57,24.57,0,0,0,138.34,44a23.05,23.05,0,0,0-3.19,2,24.34,24.34,0,0,0-2.75,2.36,26.27,26.27,0,0,0-4.12,5.3A27.31,27.31,0,0,0,125.9,59a27.6,27.6,0,0,0-1.25,8.46c0,2,.14,3.18,0,3.21s-.51-1.08-.77-3.17a24.12,24.12,0,0,1,.67-8.89,26.37,26.37,0,0,1,6.54-11.57,26.93,26.93,0,0,1,6.32-4.82,26.25,26.25,0,0,1,3.85-1.73,27.92,27.92,0,0,1,4.2-1.13,29.13,29.13,0,0,1,4.33-.43,26.61,26.61,0,0,1,4.21.25,25.32,25.32,0,0,1,4,.88,24.73,24.73,0,0,1,3.64,1.4A26.25,26.25,0,0,1,171.83,50a24.43,24.43,0,0,1,3.78,8.08C176.11,60.12,176.13,61.29,176,61.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.56,81l.74,4.49-4,.66-.73-4.36c-4,.41-8-.2-10.5-1.56L142.46,75a16.4,16.4,0,0,0,8.25,1.56l-1.11-6.69c-4.63-.35-9.84-1-10.79-6.74-.7-4.25,1.78-8.4,8-10.17l-.74-4.45,4-.66.72,4.36a18.44,18.44,0,0,1,8.54,1.1l-1.19,5.26a16.68,16.68,0,0,0-6.47-1.07l1.13,6.82c4.61.3,9.75,1,10.68,6.62C164.17,75.06,161.73,79.17,155.56,81Zm-6.94-17-.94-5.69c-2,.83-2.69,2.13-2.47,3.45S146.77,63.66,148.62,63.93Zm8.49,8.51c-.23-1.4-1.52-2-3.34-2.29l.92,5.53C156.62,74.91,157.33,73.73,157.11,72.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.65,246.8a21,21,0,1,1-23.92-17.61A21,21,0,0,1,389.65,246.8Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.7,247.54a16,16,0,1,1-18.23-13.42A16,16,0,0,1,384.7,247.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.62,247.05a9.59,9.59,0,0,1-.7-1.84,17.45,17.45,0,0,0-2.56-4.59,17,17,0,0,0-2.54-2.56,16,16,0,0,0-3.51-2.15,15.72,15.72,0,0,0-4.36-1.23,16.13,16.13,0,0,0-4.86.13,17.12,17.12,0,0,0-2.39.63,16.11,16.11,0,0,0-2.2,1,15.51,15.51,0,0,0-2,1.24,16,16,0,0,0-1.69,1.46,16,16,0,0,0-4,6.54,17,17,0,0,0-.77,5.19,8.8,8.8,0,0,1,0,2,4.82,4.82,0,0,1-.47-1.95,14.89,14.89,0,0,1,.41-5.46,16.89,16.89,0,0,1,1.41-3.55,16.74,16.74,0,0,1,4.39-5.14,16.09,16.09,0,0,1,2.1-1.36,15.31,15.31,0,0,1,2.36-1.07,18.11,18.11,0,0,1,2.58-.69,17.11,17.11,0,0,1,2.65-.26,15.82,15.82,0,0,1,2.59.15,16,16,0,0,1,2.44.54,15.62,15.62,0,0,1,2.23.86,16,16,0,0,1,6.27,5.21,14.8,14.8,0,0,1,2.32,5A4.72,4.72,0,0,1,384.62,247.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.07,259.11l.46,2.76-2.46.41-.45-2.68a11.77,11.77,0,0,1-6.44-1l.85-3.22a10,10,0,0,0,5.06,1l-.68-4.1c-2.84-.21-6-.62-6.62-4.14-.43-2.6,1.09-5.15,4.9-6.24l-.45-2.73,2.46-.41.44,2.68a11.32,11.32,0,0,1,5.24.68l-.72,3.23a10.08,10.08,0,0,0-4-.66l.69,4.18c2.84.19,6,.6,6.56,4.07C377.36,255.49,375.85,258,372.07,259.11Zm-4.26-10.46-.58-3.49c-1.25.51-1.65,1.31-1.51,2.12S366.67,248.49,367.81,248.65Zm5.21,5.23c-.14-.86-.93-1.21-2-1.41l.56,3.4C372.72,255.39,373.15,254.67,373,253.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.56,267.33a28.53,28.53,0,1,1-32.46-23.9A28.51,28.51,0,0,1,92.56,267.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.85,268.34a21.74,21.74,0,1,1-24.74-18.21A21.73,21.73,0,0,1,85.85,268.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.74,267.66a12.79,12.79,0,0,1-1-2.5A23.15,23.15,0,0,0,81.31,259a22.07,22.07,0,0,0-3.44-3.48,21.68,21.68,0,0,0-4.76-2.91,19.92,19.92,0,0,0-2.84-1,21,21,0,0,0-6.34-.81,22.25,22.25,0,0,0-3.33.34,21.3,21.3,0,0,0-6.23,2.17,21.39,21.39,0,0,0-4.95,3.66,21.63,21.63,0,0,0-5.4,8.88,23,23,0,0,0-1.05,7,12.75,12.75,0,0,1,0,2.68,6.56,6.56,0,0,1-.63-2.64,20,20,0,0,1,.56-7.4,21.59,21.59,0,0,1,5.44-9.63,22.32,22.32,0,0,1,5.26-4,21.64,21.64,0,0,1,3.21-1.44,22.28,22.28,0,0,1,7.1-1.3,22.67,22.67,0,0,1,3.51.21,22.11,22.11,0,0,1,3.31.73,22.38,22.38,0,0,1,3,1.17,22,22,0,0,1,5,3.24,22.64,22.64,0,0,1,3.49,3.83A20.11,20.11,0,0,1,85.4,265,6.5,6.5,0,0,1,85.74,267.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.71,284l.62,3.74-3.34.55-.6-3.63a16.12,16.12,0,0,1-8.75-1.3L57.8,279a13.74,13.74,0,0,0,6.87,1.3l-.92-5.58c-3.86-.28-8.2-.83-9-5.6-.58-3.54,1.48-7,6.66-8.47L60.8,257l3.34-.55.6,3.64a15.27,15.27,0,0,1,7.11.91l-1,4.38a14,14,0,0,0-5.39-.89l.94,5.67c3.84.26,8.12.82,8.9,5.52C75.88,279.11,73.84,282.53,68.71,284Zm-5.78-14.19-.78-4.74c-1.7.7-2.24,1.78-2.06,2.88S61.39,269.62,62.93,269.84ZM70,276.93c-.19-1.17-1.26-1.64-2.78-1.9l.76,4.6C69.59,279,70.18,278,70,276.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.88,197.14,254.66,142.91a8.5,8.5,0,0,1-5.59-10.63L282.58,24.66a8.49,8.49,0,0,1,10.62-5.59L467.43,73.31A8.49,8.49,0,0,1,473,83.93l-33.5,107.63A8.5,8.5,0,0,1,428.88,197.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,101,274,111.6l-1.08-.34,3-9.6-2.5-.78.31-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.19,114l-.31,1-7.41-2.31.24-.77,5.73-2.94c1.56-.8,2-1.44,2.24-2.17.38-1.22-.25-2.24-1.86-2.75a3.81,3.81,0,0,0-3.26.28l-.56-.9a5,5,0,0,1,4.22-.35c2.14.67,3.16,2.18,2.61,4-.31,1-.91,1.82-2.76,2.77l-4.7,2.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.88,115.67l-2.12-.66-.86,2.78-1.09-.34.87-2.77-6-1.86L288,112l7.78-5.26,1.21.38-7.53,5.14,4.59,1.43.76-2.45,1.06.33-.77,2.45,2.12.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.08,120.72l-2.11-.66-.87,2.78L309,122.5l.87-2.78-6-1.86.25-.78,7.78-5.27,1.21.38-7.53,5.14,4.59,1.43.76-2.44,1.06.32-.76,2.45,2.11.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.42,123.26c-.56,1.8-2.25,2.81-4.83,2a5.76,5.76,0,0,1-3.37-2.54l.8-.7a4.8,4.8,0,0,0,2.86,2.23c1.8.56,3,0,3.43-1.3s-.17-2.47-2.85-3.3l-2.25-.7,2.19-5.14,5.79,1.8-.31,1-4.83-1.5-1.41,3.25,1.36.42C322.19,119.76,323,121.39,322.42,123.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.89,126.47c-.62,2-2.57,2.76-4.63,2.12-2.8-.87-3.72-3.3-2.68-6.64,1.11-3.59,3.66-4.85,6.53-4a5.1,5.1,0,0,1,2.33,1.36l-.71.74a3.82,3.82,0,0,0-1.9-1.14c-2.28-.71-4.2.3-5.1,3.17-.07.24-.15.55-.22.87a3.53,3.53,0,0,1,3.8-.8C332.41,122.84,333.49,124.53,332.89,126.47Zm-1.09-.31c.44-1.39-.31-2.6-1.95-3.11a2.56,2.56,0,0,0-3.43,1.47c-.36,1.16.26,2.56,2.09,3.13A2.41,2.41,0,0,0,331.8,126.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.31,131.09c-.55,1.77-2.26,2.73-4.81,1.93a5.77,5.77,0,0,1-3.38-2.54l.8-.7a4.8,4.8,0,0,0,2.89,2.24c1.75.55,3,0,3.38-1.28s-.23-2.38-2.2-3l-.75-.23.25-.8,4.07-2.76-5.41-1.68.3-1,6.8,2.12-.24.77L344.85,127C347.08,127.85,347.84,129.4,347.31,131.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,134.27c-.62,2-2.57,2.76-4.62,2.12-2.81-.87-3.73-3.3-2.69-6.63,1.12-3.6,3.66-4.86,6.53-4a5,5,0,0,1,2.33,1.36l-.71.74a3.84,3.84,0,0,0-1.9-1.14c-2.28-.71-4.2.3-5.09,3.17a6.86,6.86,0,0,0-.22.87,3.54,3.54,0,0,1,3.79-.8C357.47,130.64,358.55,132.33,358,134.27Zm-1.08-.31c.43-1.39-.32-2.6-1.95-3.1a2.56,2.56,0,0,0-3.44,1.46c-.36,1.16.26,2.57,2.09,3.14A2.43,2.43,0,0,0,356.87,134Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,129.88l-.24.77-7.48,8.42-1.17-.36,7.34-8.25-5.44-1.7-.62,2-1.07-.33.92-3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.09,134.58l-.24.77-7.47,8.43-1.18-.37,7.34-8.25-5.44-1.69-.61,2-1.08-.34.92-2.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.12,145.45c-.58,1.87-2.53,2.54-5.05,1.76s-3.72-2.44-3.13-4.31a2.75,2.75,0,0,1,2.84-2,2.48,2.48,0,0,1-.93-2.84c.53-1.73,2.33-2.34,4.57-1.65s3.39,2.24,2.86,4a2.53,2.53,0,0,1-2.42,1.8A2.79,2.79,0,0,1,393.12,145.45Zm-1.11-.36c.4-1.3-.46-2.47-2.33-3.05s-3.23-.11-3.64,1.19.44,2.47,2.32,3.05S391.6,146.4,392,145.09Zm-2.07-3.91c1.65.51,2.86.08,3.22-1.07s-.44-2.24-2-2.74-2.84-.08-3.2,1.09S388.3,140.67,389.94,141.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.15,146.21c-1.12,3.6-3.67,4.86-6.54,4a5.1,5.1,0,0,1-2.33-1.36l.71-.74a4,4,0,0,0,1.9,1.14c2.28.71,4.2-.3,5.1-3.17.07-.24.15-.55.22-.87a3.55,3.55,0,0,1-3.8.8c-2.1-.65-3.18-2.35-2.57-4.28s2.56-2.76,4.62-2.12C404.27,140.45,405.18,142.87,404.15,146.21Zm-.85-2.56c.37-1.16-.26-2.57-2.08-3.14a2.43,2.43,0,0,0-3.3,1.5c-.43,1.38.31,2.59,1.95,3.1A2.55,2.55,0,0,0,403.3,143.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.48,144.35l-3.29,10.58-1.09-.34,3-9.61-2.49-.77.3-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.36,157.34l-.3,1L416.65,156l.24-.77,5.73-2.94c1.56-.8,2-1.44,2.24-2.17.38-1.22-.25-2.24-1.87-2.74a3.73,3.73,0,0,0-3.25.28l-.56-.91a5,5,0,0,1,4.22-.34c2.14.66,3.16,2.18,2.61,3.94-.32,1-.91,1.82-2.77,2.77l-4.69,2.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.49,158.23c-.55,1.76-2.26,2.72-4.81,1.93a5.78,5.78,0,0,1-3.38-2.55l.8-.69a4.83,4.83,0,0,0,2.89,2.24c1.75.55,3,0,3.38-1.28s-.24-2.38-2.2-3l-.75-.23.25-.81,4.07-2.75-5.41-1.69.3-1,6.8,2.11-.24.77L432,154.16C434.26,155,435,156.53,434.49,158.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.15,
    y: 114.95,
    width: 4.81,
    height: 88.68,
    transform: "translate(123.1 485.81) rotate(-72.71)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.92,
    y: 152.13,
    width: 4.81,
    height: 45.48,
    transform: "translate(120.72 513.74) rotate(-72.71)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 276.98,
    y: 68.27,
    width: 37.21,
    height: 27.8,
    rx: 4.96,
    transform: "matrix(0.95, 0.3, -0.3, 0.95, 37.78, -84.14)",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M276,82.56l.53-1.7,18.29,5.69a4,4,0,1,0,2.39-7.65l-18.3-5.7.53-1.7,18.3,5.69a5.8,5.8,0,0,1-3.45,11.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.06,
    y: 79.56,
    width: 1.78,
    height: 13.15,
    transform: "translate(133.23 353.45) rotate(-72.66)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.56,
    y: 56.87,
    width: 95.7,
    height: 8.21,
    transform: "translate(33.38 -97.54) rotate(17.29)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.73,
    y: 83.09,
    width: 19.26,
    height: 19.26,
    rx: 3.15,
    transform: "translate(47.42 -126.41) rotate(17.29)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.76,462c0,.14-101.53.26-226.75.26S23.24,462.09,23.24,462s101.51-.26,226.77-.26S476.76,461.8,476.76,462Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wallet--inject-64"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.49,
    y: 324.09,
    width: 157.25,
    height: 137.83,
    rx: 8.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.49,414.47H93.77a4,4,0,0,0,4-4H36.65Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 32.28,
    y: 375.21,
    width: 67.84,
    height: 35.77,
    rx: 4.99,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.13,411a6,6,0,0,0,1.94-.45A5.26,5.26,0,0,0,99,409.06,5,5,0,0,0,100,406c0-5-.05-12.31-.08-21.28,0-1.12,0-2.27,0-3.45a14.41,14.41,0,0,0-.06-1.75,4.66,4.66,0,0,0-.55-1.65,4.78,4.78,0,0,0-2.71-2.23,5.6,5.6,0,0,0-1.84-.23h-2l-16.87,0-38.65,0a4.73,4.73,0,0,0-4,2.27,4.49,4.49,0,0,0-.68,2.27c0,.82,0,1.68,0,2.51q0,5,0,9.86v9.52c0,1.54,0,3.12,0,4.59A4.75,4.75,0,0,0,34.74,410a4.84,4.84,0,0,0,2,.69c.68.07,1.44,0,2.16,0H51.34l14.7,0,21.28.09,5.79,0,1.5,0,.52,0s-.18,0-.52,0l-1.5,0-5.79.05L66,411.16l-14.7,0-8.19,0H38.87c-.74,0-1.43,0-2.21,0a5.1,5.1,0,0,1-2.17-.77,5.22,5.22,0,0,1-2.43-3.87c-.06-1.57,0-3.07,0-4.64,0-3.11,0-6.29,0-9.52v-9.86c0-.84,0-1.67,0-2.53a5.14,5.14,0,0,1,.75-2.52A5.27,5.27,0,0,1,37.27,375l38.65,0,16.87,0h2a6,6,0,0,1,2,.25,5.2,5.2,0,0,1,2.94,2.44,5.1,5.1,0,0,1,.58,1.78,13.91,13.91,0,0,1,.06,1.81c0,1.18,0,2.33,0,3.45,0,9-.07,16.24-.09,21.29a5,5,0,0,1-4.57,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.39,
    cy: 396.97,
    r: 10.04
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 83.39,
    cy: 393.47,
    r: 10.04,
    transform: "translate(-253.8 174.21) rotate(-45)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.44,393.47c-.07,0,0-.89-.42-2.43a10,10,0,0,0-3.66-5.4,9.81,9.81,0,0,0-9.31-1.37,9.25,9.25,0,0,0-2.47,1.33,9.13,9.13,0,0,0-2.07,2.09,9.76,9.76,0,0,0,0,11.57,9.91,9.91,0,0,0,4.54,3.42,9.92,9.92,0,0,0,13-6.78,24.3,24.3,0,0,0,.42-2.43,8,8,0,0,1-.22,2.48,9.94,9.94,0,0,1-3.64,5.65,10.09,10.09,0,0,1-4.29,1.95,10.29,10.29,0,0,1-5.4-.42,9.68,9.68,0,0,1-2.61-1.39,9.8,9.8,0,0,1-2.18-2.18,10.22,10.22,0,0,1,0-12.17,9.59,9.59,0,0,1,2.18-2.18,9.71,9.71,0,0,1,2.61-1.4,10.29,10.29,0,0,1,5.4-.41,10.1,10.1,0,0,1,7.93,7.6A8,8,0,0,1,93.44,393.47Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-64"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 403.97,
    cy: 342.82,
    r: 34.88,
    transform: "translate(-53.16 74.97) rotate(-9.95)",
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.45,310.26a34.86,34.86,0,0,0-20,45.07s23.27-7.77,25.23-19.1S391.45,310.26,391.45,310.26Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 403.26,
    cy: 342.5,
    r: 26.52,
    transform: "matrix(0.93, -0.36, 0.36, 0.93, -95.61, 166.29)",
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.26,
    cy: 342.5,
    r: 26.52,
    transform: "matrix(0.93, -0.36, 0.36, 0.93, -95.61, 166.29)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M429.1,333.74a26.16,26.16,0,1,1-33.8-15A26.16,26.16,0,0,1,429.1,333.74Z",
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.1,333.74a26.16,26.16,0,1,1-33.8-15A26.16,26.16,0,0,1,429.1,333.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M404.84,340.64l-2.4-6.24,0,0a14,14,0,0,1,3.66-.41,11.49,11.49,0,0,1,1.93.39v-.23l.1-2.62,0-.6-1.56-.74-.45.44a12.62,12.62,0,0,0-5,.44l-1.33-3.44-1.4-.45.33.86-1.46.57,1.34,3.5c-4.65,2.32-5.88,6-4.67,9.11,1.66,4.3,5.77,4,9.53,3.51l2.38,6.19a12.69,12.69,0,0,1-7.1,0l-.19,3.66c2.15.78,5.47.64,8.57-.34l1,2.59-1.2.49,1.52.35,2.54-1-1.33-3.47c4.67-2.36,5.94-6,4.73-9.14C412.76,339.8,408.6,340.16,404.84,340.64Zm-2.78.33c-2,.16-3.59,0-4.17-1.49s0-2.84,2.05-4Zm.38-6.58Zm5.95,15.48-2.11-5.48c2.06-.19,3.7,0,4.28,1.51C411.07,347.24,410.52,348.66,408.39,349.87Z",
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M404.84,340.64l-2.4-6.24,0,0a14,14,0,0,1,3.66-.41,11.49,11.49,0,0,1,1.93.39v-.23l.1-2.62,0-.6-1.56-.74-.45.44a12.62,12.62,0,0,0-5,.44l-1.33-3.44-1.4-.45.33.86-1.46.57,1.34,3.5c-4.65,2.32-5.88,6-4.67,9.11,1.66,4.3,5.77,4,9.53,3.51l2.38,6.19a12.69,12.69,0,0,1-7.1,0l-.19,3.66c2.15.78,5.47.64,8.57-.34l1,2.59-1.2.49,1.52.35,2.54-1-1.33-3.47c4.67-2.36,5.94-6,4.73-9.14C412.76,339.8,408.6,340.16,404.84,340.64Zm-2.78.33c-2,.16-3.59,0-4.17-1.49s0-2.84,2.05-4Zm.38-6.58Zm5.95,15.48-2.11-5.48c2.06-.19,3.7,0,4.28,1.51C411.07,347.24,410.52,348.66,408.39,349.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M408.31,352.79l1.34,3.47-2.54,1-1.32-3.44c-3.11,1-6.43,1.12-8.58.35l.19-3.66a12.78,12.78,0,0,0,7.1,0l-2.38-6.19c-3.76.48-7.87.78-9.52-3.52-1.22-3.16,0-6.79,4.66-9.11l-1.34-3.5,2.54-1,1.32,3.44a14.19,14.19,0,0,1,7-.53l-.07,3.62a13.81,13.81,0,0,0-5.66.25l2.41,6.26c3.76-.49,7.92-.85,9.57,3.46C414.26,346.81,413,350.43,408.31,352.79Zm-7.63-12.27L398.56,335c-2.07,1.19-2.57,2.66-2,4S398.68,340.69,400.68,340.52Zm8.51,4.94c-.59-1.52-2.22-1.71-4.28-1.52l2.11,5.48C409.14,348.21,409.7,346.79,409.19,345.46Z",
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.12,368.75s-.09-.06-.25-.19l-.68-.6a14.24,14.24,0,0,1-1-1c-.38-.4-.85-.83-1.3-1.37l-.72-.83c-.25-.29-.48-.62-.74-.94-.52-.64-1-1.38-1.53-2.14a37.7,37.7,0,0,1-2.86-5.31,38.75,38.75,0,0,1-1.9-5.73c-.19-.91-.39-1.77-.5-2.59-.06-.41-.13-.8-.17-1.18s-.07-.74-.11-1.09c-.08-.7-.08-1.34-.1-1.89a13.53,13.53,0,0,1,0-1.43l0-.9a.16.16,0,1,1,.06,0c0,.23,0,.53,0,.9s0,.87,0,1.42.05,1.19.15,1.88c0,.35.08.71.12,1.09s.12.76.18,1.17c.12.81.33,1.66.53,2.56a37.49,37.49,0,0,0,1.9,5.68,39,39,0,0,0,2.82,5.29c.52.76,1,1.5,1.5,2.14.25.32.48.65.73.94l.7.84c.44.54.89,1,1.27,1.39s.71.74,1,1l.65.63C382.05,368.66,382.13,368.74,382.12,368.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.71,342.53a2.27,2.27,0,0,1-1-.44,4.18,4.18,0,0,1-1.59-2.07,4.1,4.1,0,0,1,0-2.62,2.14,2.14,0,0,1,.51-1s-.17.38-.33,1a4.33,4.33,0,0,0,.08,2.48,4.41,4.41,0,0,0,1.46,2C395.34,342.34,395.72,342.49,395.71,342.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.59,330.92c-.07,0-.3-.41-.51-1s-.34-1-.27-1.06.29.41.51,1S397.66,330.9,397.59,330.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.73,316.25a4.29,4.29,0,0,1-.8.28,8.57,8.57,0,0,0-.95.31c-.37.13-.79.26-1.24.46s-.95.38-1.46.63-1.07.52-1.64.82a28.39,28.39,0,0,0-3.51,2.3,30.12,30.12,0,0,0-3.12,2.8c-.44.48-.86.92-1.22,1.37s-.7.86-1,1.26-.54.75-.76,1.07-.4.6-.54.84a4.82,4.82,0,0,1-.48.71,5.44,5.44,0,0,1,.39-.76,9.06,9.06,0,0,1,.51-.87c.21-.32.44-.71.73-1.1s.6-.84,1-1.29.78-.91,1.21-1.39a27.62,27.62,0,0,1,3.14-2.85,28.79,28.79,0,0,1,3.56-2.3c.58-.29,1.12-.58,1.66-.81s1-.43,1.49-.61.88-.3,1.25-.42.7-.21,1-.27A5.37,5.37,0,0,1,395.73,316.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.81,372.16a2.91,2.91,0,0,1-.52.38,15.75,15.75,0,0,1-1.51.9,25.12,25.12,0,0,1-11.1,3c-.74,0-1.34,0-1.76,0a3.76,3.76,0,0,1-.64-.06,3,3,0,0,1,.64,0c.42,0,1,0,1.75-.06a29.61,29.61,0,0,0,5.67-.93,29,29,0,0,0,5.36-2.06c.65-.33,1.18-.62,1.53-.82A3.2,3.2,0,0,1,419.81,372.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.06,
    y: 375.44,
    width: 73.84,
    height: 14.89,
    transform: "translate(813.96 765.76) rotate(180)",
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.15,375.68c-.17,0-.32,3.24-.32,7.22s.15,7.22.32,7.22.32-3.23.32-7.22S439.33,375.68,439.15,375.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.31,375.68c-.18,0-.32,3.24-.32,7.22s.14,7.22.32,7.22.32-3.23.32-7.22S432.48,375.68,432.31,375.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.54,375.68c-.18,0-.32,3.24-.32,7.22s.14,7.22.32,7.22.32-3.23.32-7.22S425.72,375.68,425.54,375.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.81,375.68c-.18,0-.32,3.24-.32,7.22s.14,7.22.32,7.22.32-3.23.32-7.22S419,375.68,418.81,375.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.08,375.68c-.18,0-.32,3.24-.32,7.22s.14,7.22.32,7.22.32-3.23.32-7.22S412.26,375.68,412.08,375.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.35,375.68c-.18,0-.32,3.24-.32,7.22s.14,7.22.32,7.22.32-3.23.32-7.22S405.53,375.68,405.35,375.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.62,375.68c-.18,0-.32,3.24-.32,7.22s.14,7.22.32,7.22.32-3.23.32-7.22S398.8,375.68,398.62,375.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.89,375.68c-.18,0-.32,3.24-.32,7.22s.14,7.22.32,7.22.32-3.23.32-7.22S392.07,375.68,391.89,375.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.16,375.68c-.18,0-.32,3.24-.32,7.22s.14,7.22.32,7.22.32-3.23.32-7.22S385.34,375.68,385.16,375.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.43,375.68c-.18,0-.32,3.24-.32,7.22s.14,7.22.32,7.22.32-3.23.32-7.22S378.61,375.68,378.43,375.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.7,375.68c-.18,0-.32,3.24-.32,7.22s.14,7.22.32,7.22.32-3.23.32-7.22S371.87,375.68,371.7,375.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M442.71,375.45a269.33,269.33,0,0,1-71.47,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M370,375.48c0,.18,16.5.32,36.85.32s36.86-.14,36.86-.32-16.5-.32-36.86-.32S370,375.3,370,375.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.4,
    y: 390.08,
    width: 73.84,
    height: 14.89,
    transform: "translate(810.64 795.04) rotate(180)",
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.5,390.33c-.18,0-.32,3.23-.32,7.21s.14,7.22.32,7.22.32-3.23.32-7.22S437.67,390.33,437.5,390.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.65,390.33c-.18,0-.32,3.23-.32,7.21s.14,7.22.32,7.22.32-3.23.32-7.22S430.83,390.33,430.65,390.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.88,390.33c-.17,0-.32,3.23-.32,7.21s.15,7.22.32,7.22.32-3.23.32-7.22S424.06,390.33,423.88,390.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.15,390.33c-.18,0-.32,3.23-.32,7.21s.14,7.22.32,7.22.32-3.23.32-7.22S417.33,390.33,417.15,390.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.42,390.33c-.18,0-.32,3.23-.32,7.21s.14,7.22.32,7.22.32-3.23.32-7.22S410.6,390.33,410.42,390.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.69,390.33c-.18,0-.32,3.23-.32,7.21s.14,7.22.32,7.22.32-3.23.32-7.22S403.87,390.33,403.69,390.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,390.33c-.18,0-.32,3.23-.32,7.21s.14,7.22.32,7.22.32-3.23.32-7.22S397.14,390.33,397,390.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.23,390.33c-.18,0-.32,3.23-.32,7.21s.14,7.22.32,7.22.32-3.23.32-7.22S390.41,390.33,390.23,390.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.5,390.33c-.18,0-.32,3.23-.32,7.21s.14,7.22.32,7.22.32-3.23.32-7.22S383.68,390.33,383.5,390.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77,390.33c-.18,0-.32,3.23-.32,7.21s.14,7.22.32,7.22.32-3.23.32-7.22S377,390.33,376.77,390.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,390.33c-.18,0-.32,3.23-.32,7.21s.14,7.22.32,7.22.32-3.23.32-7.22S370.22,390.33,370,390.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M441.06,390.09a269.4,269.4,0,0,1-71.48,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M368.38,390.12c0,.18,16.5.32,36.86.32s36.85-.14,36.85-.32-16.49-.32-36.85-.32S368.38,390,368.38,390.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.41,
    y: 404.49,
    width: 73.84,
    height: 14.89,
    transform: "translate(824.67 823.86) rotate(180)",
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.51,404.73c-.18,0-.32,3.24-.32,7.22s.14,7.22.32,7.22.32-3.23.32-7.22S444.68,404.73,444.51,404.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.66,404.73c-.18,0-.32,3.24-.32,7.22s.14,7.22.32,7.22.32-3.23.32-7.22S437.84,404.73,437.66,404.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.89,404.73c-.17,0-.32,3.24-.32,7.22s.15,7.22.32,7.22.32-3.23.32-7.22S431.07,404.73,430.89,404.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.16,404.73c-.17,0-.32,3.24-.32,7.22s.15,7.22.32,7.22.32-3.23.32-7.22S424.34,404.73,424.16,404.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.43,404.73c-.17,0-.32,3.24-.32,7.22s.15,7.22.32,7.22.32-3.23.32-7.22S417.61,404.73,417.43,404.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.7,404.73c-.17,0-.32,3.24-.32,7.22s.15,7.22.32,7.22.32-3.23.32-7.22S410.88,404.73,410.7,404.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,404.73c-.18,0-.32,3.24-.32,7.22s.14,7.22.32,7.22.32-3.23.32-7.22S404.15,404.73,404,404.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.24,404.73c-.18,0-.32,3.24-.32,7.22s.14,7.22.32,7.22.32-3.23.32-7.22S397.42,404.73,397.24,404.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.51,404.73c-.18,0-.32,3.24-.32,7.22s.14,7.22.32,7.22.32-3.23.32-7.22S390.69,404.73,390.51,404.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.78,404.73c-.18,0-.32,3.24-.32,7.22s.14,7.22.32,7.22.32-3.23.32-7.22S384,404.73,383.78,404.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.05,404.73c-.18,0-.32,3.24-.32,7.22s.14,7.22.32,7.22.32-3.23.32-7.22S377.23,404.73,377.05,404.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M448.07,404.5a269.4,269.4,0,0,1-71.48,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M375.39,404.53c0,.18,16.5.32,36.86.32s36.85-.14,36.85-.32-16.49-.32-36.85-.32S375.39,404.36,375.39,404.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.76,
    y: 419.27,
    width: 73.84,
    height: 14.32,
    transform: "translate(807.37 852.85) rotate(180)",
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.86,419.51c-.18,0-.32,3.1-.32,6.94s.14,6.94.32,6.94.32-3.11.32-6.94S436,419.51,435.86,419.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,419.51c-.18,0-.32,3.1-.32,6.94s.14,6.94.32,6.94.32-3.11.32-6.94S429.19,419.51,429,419.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.24,419.51c-.17,0-.32,3.1-.32,6.94s.15,6.94.32,6.94.32-3.11.32-6.94S422.42,419.51,422.24,419.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.51,419.51c-.17,0-.32,3.1-.32,6.94s.15,6.94.32,6.94.32-3.11.32-6.94S415.69,419.51,415.51,419.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.78,419.51c-.17,0-.32,3.1-.32,6.94s.15,6.94.32,6.94.32-3.11.32-6.94S409,419.51,408.78,419.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.05,419.51c-.18,0-.32,3.1-.32,6.94s.14,6.94.32,6.94.32-3.11.32-6.94S402.23,419.51,402.05,419.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.32,419.51c-.18,0-.32,3.1-.32,6.94s.14,6.94.32,6.94.32-3.11.32-6.94S395.5,419.51,395.32,419.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.59,419.51c-.18,0-.32,3.1-.32,6.94s.14,6.94.32,6.94.32-3.11.32-6.94S388.77,419.51,388.59,419.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.86,419.51c-.18,0-.32,3.1-.32,6.94s.14,6.94.32,6.94.32-3.11.32-6.94S382,419.51,381.86,419.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.13,419.51c-.18,0-.32,3.1-.32,6.94s.14,6.94.32,6.94.32-3.11.32-6.94S375.31,419.51,375.13,419.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.4,419.51c-.18,0-.32,3.1-.32,6.94s.14,6.94.32,6.94.32-3.11.32-6.94S368.58,419.51,368.4,419.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M439.42,419.28a211.27,211.27,0,0,1-71.48,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M366.74,419.31c0,.18,16.5.32,36.86.32s36.85-.14,36.85-.32S424,419,403.6,419,366.74,419.13,366.74,419.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.51,
    y: 433.6,
    width: 73.84,
    height: 14.32,
    transform: "translate(816.86 881.51) rotate(180)",
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.6,433.83c-.17,0-.32,3.11-.32,6.95s.15,6.94.32,6.94.33-3.11.33-6.94S440.78,433.83,440.6,433.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.76,433.83c-.18,0-.32,3.11-.32,6.95s.14,6.94.32,6.94.32-3.11.32-6.94S433.93,433.83,433.76,433.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,433.83c-.18,0-.32,3.11-.32,6.95s.14,6.94.32,6.94.32-3.11.32-6.94S427.17,433.83,427,433.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.26,433.83c-.18,0-.32,3.11-.32,6.95s.14,6.94.32,6.94.32-3.11.32-6.94S420.44,433.83,420.26,433.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.53,433.83c-.18,0-.32,3.11-.32,6.95s.14,6.94.32,6.94.32-3.11.32-6.94S413.71,433.83,413.53,433.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.8,433.83c-.18,0-.32,3.11-.32,6.95s.14,6.94.32,6.94.32-3.11.32-6.94S407,433.83,406.8,433.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.07,433.83c-.18,0-.32,3.11-.32,6.95s.14,6.94.32,6.94.32-3.11.32-6.94S400.25,433.83,400.07,433.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.34,433.83c-.18,0-.32,3.11-.32,6.95s.14,6.94.32,6.94.32-3.11.32-6.94S393.52,433.83,393.34,433.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.61,433.83c-.18,0-.32,3.11-.32,6.95s.14,6.94.32,6.94.32-3.11.32-6.94S386.79,433.83,386.61,433.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.88,433.83c-.18,0-.32,3.11-.32,6.95s.14,6.94.32,6.94.32-3.11.32-6.94S380.06,433.83,379.88,433.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.15,433.83c-.18,0-.32,3.11-.32,6.95s.14,6.94.32,6.94.32-3.11.32-6.94S373.32,433.83,373.15,433.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M444.16,433.61a187,187,0,0,1-71.47,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M371.49,433.64c0,.18,16.5.32,36.85.32s36.86-.14,36.86-.32-16.5-.32-36.86-.32S371.49,433.46,371.49,433.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.29,
    y: 447.72,
    width: 73.84,
    height: 14.32,
    transform: "translate(808.42 909.76) rotate(180)",
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.39,448c-.18,0-.32,3.11-.32,6.94s.14,7,.32,7,.32-3.11.32-7S436.56,448,436.39,448Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.54,448c-.18,0-.32,3.11-.32,6.94s.14,7,.32,7,.32-3.11.32-7S429.72,448,429.54,448Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.77,448c-.17,0-.32,3.11-.32,6.94s.15,7,.32,7,.32-3.11.32-7S423,448,422.77,448Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,448c-.18,0-.32,3.11-.32,6.94s.14,7,.32,7,.32-3.11.32-7S416.22,448,416,448Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.31,448c-.18,0-.32,3.11-.32,6.94s.14,7,.32,7,.32-3.11.32-7S409.49,448,409.31,448Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.58,448c-.18,0-.32,3.11-.32,6.94s.14,7,.32,7,.32-3.11.32-7S402.76,448,402.58,448Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.85,448c-.18,0-.32,3.11-.32,6.94s.14,7,.32,7,.32-3.11.32-7S396,448,395.85,448Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.12,448c-.18,0-.32,3.11-.32,6.94s.14,7,.32,7,.32-3.11.32-7S389.3,448,389.12,448Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.39,448c-.18,0-.32,3.11-.32,6.94s.14,7,.32,7,.32-3.11.32-7S382.57,448,382.39,448Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.66,448c-.18,0-.32,3.11-.32,6.94s.14,7,.32,7,.32-3.11.32-7S375.84,448,375.66,448Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.93,448c-.18,0-.32,3.11-.32,6.94s.14,7,.32,7,.32-3.11.32-7S369.11,448,368.93,448Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M440,447.74a211.27,211.27,0,0,1-71.48,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M367.27,447.77c0,.17,16.5.32,36.86.32s36.85-.15,36.85-.32-16.5-.32-36.85-.32S367.27,447.59,367.27,447.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.13,462s0-.08,0-.24,0-.43,0-.72c0-.67,0-1.6,0-2.79,0-2.46-.05-6-.08-10.37v-.16h.16l4.07,0-.17.18c0-4.19,0-9,0-14.33l.22.22h-5v-.23c0-4.43,0-9.23,0-14.21v-.24h8.89l-.24.24c0-5.3,0-10.39,0-15.17l.22.23h-7.22v-.22c0-5.18,0-9.86,0-13.88v-.18h2l-.16.17c0-4.62,0-8.32,0-10.9,0-1.25,0-2.23,0-2.93,0-.32,0-.56,0-.76a1.33,1.33,0,0,1,0-.26.9.9,0,0,1,0,.26c0,.19,0,.44,0,.76,0,.7,0,1.67.07,2.92,0,2.59.11,6.29.19,10.9v.17h-2l.17-.17c0,4,0,8.7.05,13.88l-.22-.21,7,0h.23v.23c0,4.78,0,9.87,0,15.17v.24h-8.9l.25-.24c0,5,0,9.78,0,14.21l-.23-.23h5v.22c0,5.3,0,10.14,0,14.33v.18h-4.25l.16-.16c0,4.39-.05,7.91-.07,10.37,0,1.19,0,2.12,0,2.79,0,.29,0,.53,0,.72A.75.75,0,0,1,441.13,462Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.18,251.66a30.38,30.38,0,1,1-31.43-29.3A30.39,30.39,0,0,1,468.18,251.66Z",
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.75,222.36a30.38,30.38,0,0,0-29.29,31.43s21.36.21,26.19-8.57S436.75,222.36,436.75,222.36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M460.4,251.45a23.09,23.09,0,1,1-23.89-22.27A23.09,23.09,0,0,1,460.4,251.45Z",
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M460.4,251.45a23.09,23.09,0,1,1-23.89-22.27A23.09,23.09,0,0,1,460.4,251.45Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M461.08,252.39a22.78,22.78,0,1,1-23.56-22A22.78,22.78,0,0,1,461.08,252.39Z",
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.08,252.39a22.78,22.78,0,1,1-23.56-22A22.78,22.78,0,0,1,461.08,252.39Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M439.15,251.18l-.2-5.82h0a11.65,11.65,0,0,1,3.12.7,9.17,9.17,0,0,1,1.48.86l.07-.18.83-2.13.19-.49-1.08-1.06-.49.25a10.59,10.59,0,0,0-4.26-1.07l-.11-3.21-1-.77,0,.81-1.37,0,.11,3.27c-4.48.59-6.53,3.23-6.43,6.17.14,4,3.62,4.93,6.85,5.6l.2,5.77a11,11,0,0,1-5.85-2l-1.2,3A12.6,12.6,0,0,0,437.2,263l.08,2.42-1.12.06,1.15.73,2.37-.09-.12-3.23c4.52-.62,6.59-3.24,6.49-6.18C445.91,252.74,442.38,251.85,439.15,251.18Zm-2.39-.52c-1.69-.43-2.95-1-3-2.41s.79-2.34,2.82-2.73Zm2.19-5.31Zm.5,14.43-.18-5.1c1.75.43,3.05,1,3.1,2.46C442.41,258.38,441.55,259.39,439.45,259.78Z",
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M439.15,251.18l-.2-5.82h0a11.65,11.65,0,0,1,3.12.7,9.17,9.17,0,0,1,1.48.86l.07-.18.83-2.13.19-.49-1.08-1.06-.49.25a10.59,10.59,0,0,0-4.26-1.07l-.11-3.21-1-.77,0,.81-1.37,0,.11,3.27c-4.48.59-6.53,3.23-6.43,6.17.14,4,3.62,4.93,6.85,5.6l.2,5.77a11,11,0,0,1-5.85-2l-1.2,3A12.6,12.6,0,0,0,437.2,263l.08,2.42-1.12.06,1.15.73,2.37-.09-.12-3.23c4.52-.62,6.59-3.24,6.49-6.18C445.91,252.74,442.38,251.85,439.15,251.18Zm-2.39-.52c-1.69-.43-2.95-1-3-2.41s.79-2.34,2.82-2.73Zm2.19-5.31Zm.5,14.43-.18-5.1c1.75.43,3.05,1,3.1,2.46C442.41,258.38,441.55,259.39,439.45,259.78Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M438.56,262.17l.11,3.24-2.37.08-.11-3.2a12.78,12.78,0,0,1-7.16-2.15l1.2-3a11.2,11.2,0,0,0,5.85,2l-.2-5.78c-3.23-.66-6.7-1.58-6.84-5.59-.11-3,1.94-5.59,6.43-6.18l-.12-3.27,2.37-.08.11,3.21a12.42,12.42,0,0,1,5.92,1.55l-1.08,3a12,12,0,0,0-4.73-1.4l.21,5.83c3.23.67,6.76,1.56,6.9,5.57C445.15,258.94,443.07,261.55,438.56,262.17Zm-2.8-12.27-.18-5.14c-2,.39-2.87,1.46-2.83,2.73S434.07,249.47,435.76,249.9Zm5.6,6.48c-.05-1.41-1.34-2-3.09-2.46l.18,5.11C440.54,258.64,441.4,257.62,441.36,256.38Z",
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.7,276.2l.19,0,.54-.06.89-.08a8.54,8.54,0,0,0,1.21-.17l1.5-.29a5.61,5.61,0,0,0,.85-.22l.9-.27a9.7,9.7,0,0,0,1-.31l1-.4c.34-.15.7-.27,1-.45l1.07-.56a24.39,24.39,0,0,0,4.39-3.05l1.05-1c.18-.17.36-.34.53-.52l.5-.59c.32-.39.68-.78,1-1.2s.61-.87.92-1.31l.23-.34a4.05,4.05,0,0,0,.21-.35l.4-.72.41-.73a6.76,6.76,0,0,0,.36-.77c.22-.52.47-1,.68-1.57l.54-1.67a22.69,22.69,0,0,0-.5-14.32q-.33-.83-.66-1.62c-.24-.53-.53-1-.79-1.53a6.65,6.65,0,0,0-.41-.74c-.15-.23-.3-.47-.46-.7l-.45-.69-.23-.34-.25-.31-1-1.25c-.34-.4-.72-.76-1.08-1.13l-.53-.55-.57-.49-1.12-1a24.13,24.13,0,0,0-4.6-2.73l-1.09-.49c-.36-.15-.73-.25-1.08-.37l-1-.34c-.33-.11-.67-.16-1-.24l-.92-.2a5.61,5.61,0,0,0-.86-.16l-1.52-.19a9.17,9.17,0,0,0-1.21-.08l-.9,0-.55,0-.19,0h1.64a8.93,8.93,0,0,1,1.22.05l1.53.17a7.07,7.07,0,0,1,.86.15l.93.2c.31.08.65.12,1,.23l1,.33c.35.13.72.22,1.08.37l1.11.48a24.37,24.37,0,0,1,4.64,2.73l1.14,1c.19.16.39.32.57.49l.54.55c.36.37.75.73,1.09,1.13l1,1.26.26.32.23.34c.15.23.31.46.46.7l.47.7c.16.23.27.5.41.75.26.5.55,1,.8,1.53s.44,1.09.67,1.64a25,25,0,0,1,1.42,7.19,24.57,24.57,0,0,1-.92,7.28c-.18.56-.37,1.12-.55,1.67s-.46,1.07-.69,1.59a7.83,7.83,0,0,1-.36.78l-.41.73-.41.73-.21.36-.24.33-.92,1.33c-.32.42-.68.81-1,1.2l-.5.59-.54.53-1.07,1a23.83,23.83,0,0,1-4.44,3.05l-1.07.56c-.35.17-.72.29-1.06.44l-1,.4a9.75,9.75,0,0,1-1,.3l-.91.27a7.51,7.51,0,0,1-.85.21l-1.51.27a8.46,8.46,0,0,1-1.22.14l-.89.07-.55,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.46,267.87s-.06-.07-.15-.23l-.39-.68c-.17-.29-.37-.66-.58-1.1s-.46-.93-.68-1.5c-.11-.29-.23-.58-.36-.89s-.22-.64-.34-1c-.25-.68-.44-1.42-.65-2.2a30,30,0,0,1-.78-10.44c.09-.8.17-1.57.32-2.27.06-.36.11-.7.19-1s.15-.64.23-.94c.12-.59.31-1.12.44-1.58s.28-.86.41-1.18.21-.54.28-.73a1,1,0,0,1,.12-.25,1.29,1.29,0,0,1-.07.27c-.07.19-.15.44-.25.74s-.24.72-.36,1.18-.3,1-.42,1.59q-.1.45-.21.93c-.07.33-.11.67-.18,1-.13.7-.2,1.46-.3,2.26a36,36,0,0,0-.05,5.22,34.66,34.66,0,0,0,.83,5.15c.21.77.39,1.51.63,2.19.11.34.21.67.33,1l.34.89c.21.57.45,1.06.65,1.5s.38.82.54,1.12l.35.7A1,1,0,0,1,412.46,267.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.09,250.14a1.93,1.93,0,0,1-.69-.64,3.63,3.63,0,0,1-.73-2.16,3.67,3.67,0,0,1,.73-2.16,1.92,1.92,0,0,1,.7-.65s-.26.26-.57.74a3.72,3.72,0,0,0,0,4.14C430.84,249.88,431.12,250.11,431.09,250.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.94,241.12a2.12,2.12,0,0,1-.15-.94,2.15,2.15,0,0,1,.08-1c.07,0,.13.42.15.95A2.09,2.09,0,0,1,435.94,241.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.58,228.51a3.62,3.62,0,0,1-.75,0c-.23,0-.53,0-.86,0s-.73,0-1.15,0-.89,0-1.39.11-1,.13-1.58.21a27,27,0,0,0-3.54.89,25.87,25.87,0,0,0-3.37,1.43c-.49.27-1,.51-1.39.78s-.82.51-1.17.75-.66.47-.93.67-.51.38-.69.53a3.17,3.17,0,0,1-.59.45,5.27,5.27,0,0,1,.53-.51c.18-.17.4-.36.67-.57s.56-.46.92-.7.73-.52,1.16-.78.9-.53,1.39-.81a24.85,24.85,0,0,1,3.39-1.45,25.13,25.13,0,0,1,3.58-.88c.57-.08,1.1-.17,1.6-.2s1-.07,1.4-.08.82,0,1.16,0,.63,0,.87,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.52,281.39a3.19,3.19,0,0,1-.53.16,13.08,13.08,0,0,1-1.5.31,22,22,0,0,1-5,.24,22.29,22.29,0,0,1-5-.91c-.61-.2-1.11-.37-1.44-.52a3.1,3.1,0,0,1-.51-.23,2.21,2.21,0,0,1,.54.15c.34.12.84.27,1.46.44a25,25,0,0,0,4.93.85,25.53,25.53,0,0,0,5-.17c.64-.09,1.15-.18,1.51-.24A2,2,0,0,1,442.52,281.39Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.7,461.65,204.25,461a29.51,29.51,0,0,1-29.37-29.64L176.31,91.8A29.52,29.52,0,0,1,206,62.41L341.41,63a29.51,29.51,0,0,1,29.37,29.63l-1.43,339.6A29.5,29.5,0,0,1,339.7,461.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.22,74.76,315,74.64l-76.71-.36-9.23,0-23-.1a20.66,20.66,0,0,0-20.76,20.57l-1.4,331.48a20.66,20.66,0,0,0,20.57,20.75l135.19.62A20.66,20.66,0,0,0,360.39,427l1.4-331.48A20.66,20.66,0,0,0,341.22,74.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.22,104.88a1.69,1.69,0,1,1-1.68-1.69A1.69,1.69,0,0,1,342.22,104.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.2,111a1.69,1.69,0,1,1-1.69-1.7A1.7,1.7,0,0,1,342.2,111Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.18,117.05a1.7,1.7,0,1,1-1.69-1.69A1.7,1.7,0,0,1,342.18,117.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.37,
    y: 162.65,
    width: 144.1,
    height: 91.42,
    rx: 4.3,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.41,
    y: 156.71,
    width: 144.1,
    height: 91.42,
    rx: 4.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.84,
    y: 151.78,
    width: 144.1,
    height: 91.42,
    rx: 4.3,
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.57,172.66c0,1.17-.93,1.85-2.71,1.85h-3.49v-6.77h3.3c1.69,0,2.56.71,2.56,1.76a1.63,1.63,0,0,1-.9,1.49A1.66,1.66,0,0,1,223.57,172.66Zm-4.65-3.74v1.6h1.56c.76,0,1.18-.27,1.18-.8s-.42-.8-1.18-.8ZM222,172.5c0-.57-.44-.84-1.25-.84h-1.83v1.67h1.83C221.56,173.33,222,173.08,222,172.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.21,173.06h-3.14l-.6,1.45h-1.61l3-6.77h1.55l3,6.77h-1.64Zm-.49-1.19-1.08-2.59-1.07,2.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.36,167.74v6.77h-1.29l-3.37-4.11v4.11h-1.55v-6.77h1.3l3.36,4.11v-4.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.42,171.85l-.91,1v1.71H240v-6.77h1.56v3.16l3-3.16h1.74l-2.8,3,3,3.75h-1.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3,200.79h-1.24v1.63h-.64v-1.63h-3.5v-.46l3.29-4.12h.71l-3.17,4h2.69v-1.43h.62v1.43h1.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.86,200.64c0,1-.75,1.84-2.25,1.84a3.23,3.23,0,0,1-2.24-.8l.32-.51a2.69,2.69,0,0,0,1.92.72c1,0,1.6-.48,1.6-1.25s-.53-1.23-1.68-1.23h-.44v-.47l1.72-2.16h-3.18v-.57h4v.46l-1.75,2.21C226.2,199,226.86,199.65,226.86,200.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.88,200.6c0,1.05-.73,1.88-2.25,1.88a3.22,3.22,0,0,1-2.23-.8l.32-.51a2.64,2.64,0,0,0,1.9.72c1.06,0,1.62-.51,1.62-1.27s-.5-1.29-2.08-1.29h-1.32l.32-3.12h3.4v.57h-2.84l-.22,2h.8C231.17,198.76,231.88,199.5,231.88,200.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.36,200.57a1.94,1.94,0,0,1-2.12,1.91c-1.65,0-2.55-1.15-2.55-3.11,0-2.11,1.15-3.21,2.84-3.21a2.83,2.83,0,0,1,1.47.34l-.26.51a2.16,2.16,0,0,0-1.2-.29c-1.34,0-2.2.86-2.2,2.55,0,.14,0,.31,0,.5a2,2,0,0,1,1.9-1.06A1.88,1.88,0,0,1,237.36,200.57Zm-.63,0c0-.82-.61-1.34-1.56-1.34a1.44,1.44,0,0,0-1.6,1.35c0,.69.57,1.34,1.64,1.34A1.36,1.36,0,0,0,236.73,200.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.77,202.42l-1.48-1.95-1.49,1.95h-.71l1.85-2.39-1.76-2.27h.71l1.4,1.82,1.4-1.82h.7L249.63,200l1.86,2.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.51,202.42,254,200.47l-1.49,1.95h-.71l1.85-2.39-1.76-2.27h.71l1.4,1.82,1.4-1.82h.69L254.37,200l1.86,2.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.25,202.42l-1.48-1.95-1.49,1.95h-.71l1.84-2.39-1.76-2.27h.71l1.41,1.82,1.4-1.82h.69L259.1,200l1.87,2.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,202.42l-1.48-1.95L262,202.42h-.71l1.85-2.39-1.76-2.27h.71l1.4,1.82,1.4-1.82h.7L263.84,200l1.86,2.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.34,202.42l-1.48-1.95-1.49,1.95h-.71L279.5,200l-1.75-2.27h.71l1.4,1.82,1.4-1.82H282L280.19,200l1.87,2.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.07,202.42l-1.48-1.95-1.49,1.95h-.71l1.85-2.39-1.76-2.27h.71l1.4,1.82,1.4-1.82h.7L284.93,200l1.86,2.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.81,202.42l-1.48-1.95-1.49,1.95h-.71L289,200l-1.76-2.27h.71l1.4,1.82,1.4-1.82h.69L289.67,200l1.86,2.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.55,202.42l-1.48-1.95-1.49,1.95h-.71l1.84-2.39L292,197.76h.71l1.41,1.82,1.4-1.82h.69L294.4,200l1.87,2.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.24,196.21v6.21h-.64v-5.64h-1.47v-.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.82,200.64c0,1-.75,1.84-2.25,1.84a3.23,3.23,0,0,1-2.24-.8l.32-.51a2.67,2.67,0,0,0,1.92.72c1,0,1.6-.48,1.6-1.25s-.53-1.23-1.68-1.23h-.44v-.47l1.72-2.16h-3.18v-.57h4v.46l-1.75,2.21C315.16,199,315.82,199.65,315.82,200.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,200.79h-1.25v1.63h-.63v-1.63h-3.51v-.46l3.29-4.12h.71l-3.17,4h2.69v-1.43h.62v1.43H322Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.79,201.86v.56h-4.36V202l2.58-2.53c.7-.69.84-1.11.84-1.53,0-.72-.51-1.16-1.46-1.16a2.08,2.08,0,0,0-1.69.69l-.46-.39a2.8,2.8,0,0,1,2.2-.89c1.26,0,2.06.64,2.06,1.68a2.54,2.54,0,0,1-1,1.94l-2.11,2.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.73,215.31a1.52,1.52,0,0,1,1.61-1.53,1.54,1.54,0,0,1,1.21.52l-.44.41a.94.94,0,0,0-.74-.35.95.95,0,1,0,0,1.9.94.94,0,0,0,.74-.35l.44.4a1.49,1.49,0,0,1-1.22.53A1.52,1.52,0,0,1,213.73,215.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.91,216.16h-1.37l-.27.63h-.7l1.32-3h.68l1.32,3h-.71Zm-.21-.52-.47-1.14-.47,1.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.1,216.79l-.58-.82h-.63v.82h-.68v-3h1.28c.79,0,1.29.41,1.29,1.07a1,1,0,0,1-.61.94l.66.95Zm-.65-2.4h-.56v1h.56c.42,0,.63-.19.63-.52S221.87,214.39,221.45,214.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09,216.5l.23-.52a1.7,1.7,0,0,0,1,.31c.41,0,.57-.13.57-.31,0-.56-1.72-.18-1.72-1.28,0-.5.41-.92,1.25-.92a2,2,0,0,1,1,.26l-.21.52a1.76,1.76,0,0,0-.82-.23c-.41,0-.57.15-.57.34,0,.54,1.73.17,1.73,1.25,0,.5-.42.92-1.26.92A2.14,2.14,0,0,1,223.09,216.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,213.83v3h-.69v-1.21h-1.35v1.21h-.68v-3h.68V215h1.35v-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.47,215.31a1.62,1.62,0,1,1,1.62,1.53A1.53,1.53,0,0,1,230.47,215.31Zm2.55,0a.93.93,0,1,0-.93.95A.91.91,0,0,0,233,215.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.23,213.83h.69v2.4h1.48v.56h-2.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.79,213.83h1.35a1.49,1.49,0,1,1,0,3h-1.35Zm1.32,2.4a.92.92,0,1,0,0-1.84h-.63v1.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.59,216.24v.55H240.3v-3h2.23v.55H241V215h1.37v.54H241v.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,216.79l-.58-.82h-.63v.82h-.68v-3h1.28c.79,0,1.29.41,1.29,1.07a1,1,0,0,1-.61.94l.66.95Zm-.65-2.4h-.56v1h.56c.42,0,.63-.19.63-.52S244.8,214.39,244.38,214.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.05,
    y: 224.16,
    width: 43.95,
    height: 3.8,
    rx: 1.59,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.23,
    y: 224.16,
    width: 24.42,
    height: 3.8,
    rx: 1.59,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.17,151.78H204.62a4.78,4.78,0,0,0-4.78,4.77v24.14c8.5,5.93,20.18,7,30.54,4.81,12.21-2.55,23.27-8.8,34.64-13.92s23.88-9.22,36.17-7.11c11.61,2,21.5,9.21,32,14.56a62.07,62.07,0,0,0,10.76,4.34V156.55A4.78,4.78,0,0,0,339.17,151.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 202.85,
    y: 278.82,
    width: 37.41,
    height: 37.41,
    rx: 8.78,
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.25,303.25h-8.18a.47.47,0,0,1-.46-.37l-3-12h-2.84a.49.49,0,0,1,0-1H214a.49.49,0,0,1,.47.37l3,12h7.8a.49.49,0,0,1,0,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.62,
    cy: 305.56,
    r: 1.53,
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.62,307.57a2,2,0,1,1,2-2A2,2,0,0,1,218.62,307.57Zm0-3.06a1,1,0,1,0,1,1.05A1.06,1.06,0,0,0,218.62,304.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.13,
    cy: 305.56,
    r: 1.53,
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.13,307.57a2,2,0,1,1,2-2A2,2,0,0,1,227.13,307.57Zm0-3.06a1,1,0,1,0,1.05,1.05A1,1,0,0,0,227.13,304.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.44,301H216.8a.48.48,0,0,1-.49-.48.49.49,0,0,1,.49-.48H228l1.28-7.21H214.63a.48.48,0,1,1,0-1H229.9a.5.5,0,0,1,.37.17.47.47,0,0,1,.1.4l-1.45,8.17A.48.48,0,0,1,228.44,301Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.67,
    y: 285.39,
    width: 75.89,
    height: 9.03,
    rx: 3.77,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.67,
    y: 303.14,
    width: 38.36,
    height: 9.03,
    rx: 3.77,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.09,264.73c0,.14-39.49.26-88.19.26s-88.21-.12-88.21-.26,39.49-.26,88.21-.26S360.09,264.59,360.09,264.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.31,
    y: 331.22,
    width: 115.04,
    height: 38.79,
    rx: 16.21,
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.56,348.78c0,2-1.46,3.16-3.8,3.16h-1.5v2.24h-2.42v-8.57h3.92C269.1,345.61,270.56,346.83,270.56,348.78Zm-2.44,0c0-.79-.51-1.26-1.51-1.26h-1.35V350h1.35C267.61,350,268.12,349.57,268.12,348.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.05,352.52h-3.62l-.68,1.66h-2.47l3.78-8.57h2.39l3.79,8.57h-2.52Zm-.71-1.79-1.1-2.74-1.1,2.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,351.11v3.07h-2.42v-3.11l-3.27-5.46h2.56l2,3.41,2-3.41h2.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.14,
    cy: 113.69,
    r: 7.47,
    transform: "translate(47.23 287.1) rotate(-76.67)",
    style: {
      fill: "#306BD7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.92,
    y: 109.85,
    width: 55.94,
    height: 6.55,
    rx: 2.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.39,
    y: 381.2,
    width: 114.19,
    height: 7.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8,385c1,.34,14.38.34,14.38,26.75s-.67,59.18,13.37,60.18,87.93,0,87.93,0V405.65a20.09,20.09,0,0,0-20-20.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8,385l55.54.17,28.18.1,7.72,0a44.94,44.94,0,0,1,8,.39A20.1,20.1,0,0,1,339.66,395a20.16,20.16,0,0,1,2.89,8.16,36.14,36.14,0,0,1,.18,4.41V412c0,5.94,0,12,0,18.2v42h-.26c-25.84.31-50.41.54-72.75.36-2.79,0-5.54-.07-8.26-.12s-5.39-.07-8.07-.44a9,9,0,0,1-3.62-1.7,13.25,13.25,0,0,1-2.6-2.95,26.44,26.44,0,0,1-3-7,77.27,77.27,0,0,1-2.38-14.17c-.41-4.58-.59-9-.69-13.21-.22-8.43,0-16.05-.15-22.73s-1.16-12.43-3.22-16.65a18.21,18.21,0,0,0-3.58-5.05,13.59,13.59,0,0,0-3.77-2.51,18.51,18.51,0,0,0-3.61-1l.95.15a12.34,12.34,0,0,1,2.7.78,13.67,13.67,0,0,1,3.84,2.5,18.29,18.29,0,0,1,3.65,5.07c2.11,4.24,3.17,10.05,3.33,16.73s0,14.31.23,22.73c.11,4.2.3,8.61.72,13.19a77.67,77.67,0,0,0,2.39,14.08,26.14,26.14,0,0,0,2.94,6.87,12.8,12.8,0,0,0,2.51,2.84,8.81,8.81,0,0,0,3.43,1.61c2.56.34,5.29.32,8,.41s5.47.1,8.26.12c22.32.15,46.9-.1,72.74-.41l-.26.26V430.18c0-6.18,0-12.26,0-18.2v-4.44a34.72,34.72,0,0,0-.16-4.35,19.78,19.78,0,0,0-15.93-17,45.31,45.31,0,0,0-7.88-.4l-7.69-.05-28-.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.89,471.94s11.56,0,14-17.05c2.95-20.32,0-38.12,15.71-38.79s57.84,0,57.84,0v55.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.67,416.3s12.67-1.53,12.67,19.53.33,35,14.37,36.55,100.31,0,100.31,0-13.71-6.46-14.71-25.52-5-30.68-18.73-31.05S282.67,416.3,282.67,416.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.67,416.3l.85,0,2.49,0,9.61-.15,35.35-.38,24.44-.17,13.63,0c2.34,0,4.72,0,7.13.07a20.28,20.28,0,0,1,7.24,1.39,14.66,14.66,0,0,1,5.88,4.72,24.5,24.5,0,0,1,3.47,6.91,68,68,0,0,1,2.63,15.66c.09,1.35.16,2.7.31,4l.2,2,.38,2,.18,1,.28,1,.56,2a35,35,0,0,0,1.59,3.8,27.49,27.49,0,0,0,11.24,12.08l.87.48-1,0-2.39,0c-23.15.38-45.2.63-65.26.62-10,0-19.57,0-28.49-.42a40.64,40.64,0,0,1-6.56-.71,13.29,13.29,0,0,1-5.69-2.87,13.94,13.94,0,0,1-3.52-5,26.43,26.43,0,0,1-1.69-5.6,69.41,69.41,0,0,1-1.08-10.78c-.13-3.42-.14-6.64-.14-9.66,0-1.5,0-3-.07-4.35,0-.7,0-1.38-.1-2.05s-.16-1.32-.24-1.95l-.12-.95c-.06-.31-.13-.61-.2-.91-.13-.6-.27-1.19-.39-1.76l-.56-1.62-.27-.77-.36-.72a12.19,12.19,0,0,0-3.32-4.45,9.79,9.79,0,0,0-3.56-2,9.53,9.53,0,0,0-2.48-.45c-.29,0-.5,0-.65,0h-.21a1.92,1.92,0,0,1,.21,0,5.66,5.66,0,0,1,.65,0,9.42,9.42,0,0,1,2.51.41,9.71,9.71,0,0,1,3.63,1.95,12.38,12.38,0,0,1,3.41,4.48c2,3.83,2.43,9.18,2.41,15.17,0,3,0,6.24.18,9.65a71.1,71.1,0,0,0,1.11,10.72,26.13,26.13,0,0,0,1.68,5.52A13.55,13.55,0,0,0,301.9,469a12.69,12.69,0,0,0,5.52,2.76,39,39,0,0,0,6.48.68c8.91.37,18.44.38,28.47.38,20.05,0,42.1-.29,65.25-.66l2.39-.05-.11.5a28,28,0,0,1-11.48-12.32,36.28,36.28,0,0,1-1.61-3.87l-.57-2-.28-1-.19-1-.38-2-.2-2c-.15-1.37-.22-2.71-.31-4a67.24,67.24,0,0,0-2.6-15.55A23.93,23.93,0,0,0,388.9,422a14.17,14.17,0,0,0-5.68-4.58,20,20,0,0,0-7.06-1.37c-2.41,0-4.78-.06-7.12-.08H355.41l-24.44.1-35.35.22-9.61.05h-2.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,416.27c0,.06-1,0-2.8.21a12.11,12.11,0,0,0-6.73,3.27c-2.35,2.19-4.11,5.78-5,9.93s-1,8.92-1.17,13.87a68.84,68.84,0,0,1-1.62,13.91,32.86,32.86,0,0,1-2.07,5.77,21.26,21.26,0,0,1-2.73,4.6,11.51,11.51,0,0,1-3.37,2.85,11.9,11.9,0,0,1-3.16,1.09,12.89,12.89,0,0,1-2.09.19,4.07,4.07,0,0,1-.73,0,3.54,3.54,0,0,1,.73-.09,13.54,13.54,0,0,0,2-.28,11.69,11.69,0,0,0,3.05-1.15,11.07,11.07,0,0,0,3.24-2.83,21.57,21.57,0,0,0,2.62-4.54,34.46,34.46,0,0,0,2-5.71,70.57,70.57,0,0,0,1.56-13.82c.21-4.93.28-9.7,1.22-13.94s2.75-7.87,5.21-10.1a12,12,0,0,1,6.95-3.2,9.33,9.33,0,0,1,1.21-.09,8.39,8.39,0,0,1,.89,0A3.81,3.81,0,0,1,286,416.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.08,400.32c0,.14-16.2.26-36.18.26s-36.18-.12-36.18-.26,16.19-.26,36.18-.26S328.08,400.17,328.08,400.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.58,411.08c0,.14-15.67.26-35,.26s-35-.12-35-.26,15.66-.26,35-.26S329.58,410.94,329.58,411.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.91,432c0,.15-16.2.26-36.18.26s-36.18-.11-36.18-.26,16.2-.26,36.18-.26S378.91,431.87,378.91,432Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.81,444.57c0,.14-14.86.26-33.19.26s-33.19-.12-33.19-.26,14.86-.26,33.19-.26S379.81,444.43,379.81,444.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.15,
    y: 164.45,
    width: 13.34,
    height: 13.34,
    rx: 3.15,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.85,149.81l-6.61-.8a25.41,25.41,0,1,1,6.54-6.33h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.85,149.81s0-.17,0-.49,0-.78,0-1.38c0-1.22-.06-3-.1-5.27l.15.07h0a.09.09,0,0,1-.13,0,.11.11,0,0,1,0-.12,25.16,25.16,0,0,0,4.45-11.3,25.6,25.6,0,0,0-.21-8,25.34,25.34,0,0,0-3.27-8.47,25.81,25.81,0,0,0-6.85-7.33,24.59,24.59,0,0,0-9.94-4.29,25.66,25.66,0,0,0-11.5.49,24.65,24.65,0,0,0-10.48,6,25.36,25.36,0,0,0-4,4.77c-.51.89-1,1.77-1.48,2.68l-.6,1.4-.29.69-.23.72a25.82,25.82,0,0,0-1,11.58,24.58,24.58,0,0,0,3.92,10.21,25.28,25.28,0,0,0,15.52,10.78l2.1.36c.69.11,1.38.12,2,.19a22.65,22.65,0,0,0,3.88-.08,25.28,25.28,0,0,0,11.42-4h.06l4.87.64,1.28.18.45.07-.42,0-1.26-.13-4.94-.54.06,0a25.23,25.23,0,0,1-11.49,4.19,22.17,22.17,0,0,1-3.93.1c-.68-.06-1.37-.07-2.07-.17l-2.13-.36a25.58,25.58,0,0,1-8.54-3.62A26.26,26.26,0,0,1,30.87,142a24.91,24.91,0,0,1-4-10.37,26.15,26.15,0,0,1,1-11.79l.23-.73.3-.71c.21-.47.41-1,.61-1.42.45-.94,1-1.83,1.5-2.74a26.28,26.28,0,0,1,4-4.86,25,25,0,0,1,10.66-6.06A26,26,0,0,1,57,102.79a24.83,24.83,0,0,1,10.1,4.39A26,26,0,0,1,74,114.64a25.52,25.52,0,0,1,3.29,8.61,26.18,26.18,0,0,1,.17,8.11,25.28,25.28,0,0,1-4.59,11.37l-.14-.12h0a.09.09,0,0,1,.13,0,.07.07,0,0,1,0,.06V148c0,.58,0,1,0,1.36S72.85,149.81,72.85,149.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.97 129.45 44.14 126.05 50.68 131.48 62.73 119.07 65.89 122.25 50.43 137.84 40.97 129.45",
    style: {
      fill: "#306BD7"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletPana);
export default __webpack_public_path__ + "static/media/wallet-pana.9e96496f2b363507ea05ca3171bdf4f3.svg";
export { ForwardRef as ReactComponent };